import React from "react";
import ProjectTitle from "../ProjectTitle/ProjectTitle";
import { BASE_URL} from "../../utils/config";
import "./ProjectBlock.scss";

export const ProjectBlock = ({
  imagePath,
  alt,
  title,
  side
}) => {
  return (
    <div className={"ProjectBlock"}>
      <div>
        <img src={BASE_URL + imagePath} alt={alt} width={"640"} height={"360"} />
      </div>
      <ProjectTitle
        title={title}
        side={side}
      />
    </div>
  );
};